import { load, save } from './storage'
import { apiFetch, setToken, getToken } from './api'

const AUTH_KEY = 'session'

export function getSession() {
  return load(AUTH_KEY, null)
}

function persistSession(token, session) {
  setToken(token)
  save(AUTH_KEY, session)
}

export async function logout() {
  try {
    if (getToken()) {
      await apiFetch('/api/auth/logout', { method: 'POST' })
    }
  } catch {
    // Ignore logout audit failures so users can always clear local session.
  } finally {
    setToken('')
    localStorage.removeItem('sms_admin_session')
  }
}

export function clearSession() {
  setToken('')
  localStorage.removeItem('sms_admin_session')
}

export async function login(username, password) {
  const data = await apiFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  })
  persistSession(data.token, data.session)
  return { ok: true }
}

export async function register(username, password) {
  const data = await apiFetch('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  })
  persistSession(data.token, data.session)
  return { ok: true }
}

export async function refreshSession() {
  if (!getToken()) return null
  try {
    const data = await apiFetch('/api/auth/session')
    save(AUTH_KEY, data.session)
    return data.session
  } catch {
    clearSession()
    return null
  }
}

export function isLoggedIn() {
  return !!getToken()
}

export function getRole() {
  const session = getSession()
  return session?.role || 'admin'
}

export function isSuperAdmin() {
  return getRole() === 'super_admin'
}
